import type { BuyerBidV2DetailDto, EspdRepresentativeDto } from "../../../../autogen/bff-api";

export const BID_DETAIL_DASH = "–";

export interface BidContactSummary {
  contactName: string;
  email: string;
  phone: string;
  organizationNumber: string;
}

const display = (value: string | null | undefined): string => {
  if (value == null) return BID_DETAIL_DASH;
  const trimmed = value.trim();
  return trimmed === "" ? BID_DETAIL_DASH : trimmed;
};

const isCompleteRepresentative = (representative: EspdRepresentativeDto): boolean => {
  const contactName = `${representative.firstName} ${representative.familyName}`.trim();
  return display(contactName) !== BID_DETAIL_DASH && display(representative.email) !== BID_DETAIL_DASH;
};

export const getBidContactSummary = (
  detail: BuyerBidV2DetailDto,
  moreLabel: string,
): BidContactSummary => {
  const representatives = detail.bid.espdResponse?.economicOperator?.representatives ?? [];
  const representative = representatives.find(isCompleteRepresentative) ?? representatives[0];
  const extraRepresentatives = Math.max(0, representatives.length - 1);
  const contactName = representative
    ? `${representative.firstName} ${representative.familyName}`.trim()
    : undefined;
  const displayedContactName = display(contactName);
  const contactNameWithExtras =
    displayedContactName !== BID_DETAIL_DASH && extraRepresentatives > 0
      ? `${displayedContactName} (+${extraRepresentatives} ${moreLabel})`
      : displayedContactName;

  return {
    contactName: contactNameWithExtras,
    email: display(representative?.email),
    phone: display(representative?.telephone),
    organizationNumber: display(detail.ownerOrganizationNumber),
  };
};
